import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import OffersSlimComponent, { type OffersSlimIndexProps } from '@cx-modules/offers-slim';

import { OffersClickoutGuard } from '~/modules/offers-clickout';

const isFE = typeof window !== 'undefined';

export const OffersSlim = (propsIn: OffersSlimIndexProps) => {
  const { i18n } = useTranslation();

  const props = isFE
    ? {
        ...propsIn,
        analyticsDataLayer: window.dataLayer,
        i18n,
      }
    : {
        ...propsIn,
        i18n,
      };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <OffersClickoutGuard componentName="OffersSlim" values={props}>
        <OffersSlimComponent {...props} />
      </OffersClickoutGuard>
    </ErrorBoundary>
  );
};

type OffersSlimContentContractProps = {
  [key: string]: unknown;
  autoHideTerms?: boolean;
  geoTargeting?: boolean | string;
  repub: string;
  subdivision?: string;
};

export const OffersSlimContentContractForPageTemplate = ({
  autoHideTerms,
  geoTargeting,
  repub,
  subdivision,
  ...props
}: OffersSlimContentContractProps) => {
  return {
    ...props,
    apiKey: ENV.OC_API_KEY[repub as keyof typeof ENV.OC_API_KEY],
    variant: autoHideTerms ? 'autohide' : 'default',
    subdivisionCode: subdivision,
    repub,
    geoTargeting,
    inheritFontFamily: true,
    ...(geoTargeting === false
      ? {
          countryCode: undefined,
          subdivisionCode: undefined,
        }
      : {}),
  };
};
